// src/CreatorUser/CreatorPages/Dashboard/Bio/CreatorBio.js
import React from "react";
import { useMediaQuery, Box, Fade } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CreatorBioDesktop from "./desktopEditor";
import CreatorBioMobile from "./mobileEditor";

/**
 * Main CreatorBio component that routes to device-specific editors
 * Enhanced with better responsive detection and smooth transitions
 */
export default function CreatorBio() {
  const theme = useTheme();
  
  // Enhanced responsive detection with multiple breakpoints
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  // Log device type for debugging (remove in production)
  React.useEffect(() => {
    const deviceType = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
    console.log(`Bio Page Editor loaded for: ${deviceType}`);
  }, [isMobile, isTablet, isDesktop]);

  // Render with smooth transitions
  return (
    <Box sx={{ minHeight: '100vh' }}>
      {isMobile ? (
        <Fade in key="mobile" timeout={300}>
          <div>
            <CreatorBioMobile />
          </div>
        </Fade>
      ) : (
        <Fade in key="desktop" timeout={300}>
          <div>
            <CreatorBioDesktop />
          </div>
        </Fade>
      )}
    </Box>
  );
}